import axios from 'axios'
import { loginPagePath } from '@/utils/loginFlow'
import { syncAppLogin, syncAppSessionFromStorage } from '@/utils/appAuth'

/** 后端 accessExpire 为绝对 Unix 秒；H5 兜底可能传相对秒数 */
export function resolveAccessExpireMs(accessExpire) {
  const n = Number(accessExpire)
  if (!n) return Date.now() + 7200 * 1000
  if (n > 1e12) return n
  if (n > 1e9) return n * 1000
  return Date.now() + n * 1000
}

// 登录状态管理
class AuthManager {
  constructor() {
    this.token = localStorage.getItem('jwt_token')
    this.userInfo = JSON.parse(localStorage.getItem('user_info') || '{}')
    this.uuid = localStorage.getItem('uuid')
    this.keepLoginTimer = null
    this.expireTime = parseInt(localStorage.getItem('expire_time')) || null
    
    // 检查是否过期
    if (this.expireTime && this.expireTime < Date.now()) {
      this.logout()
      window.location.href = loginPagePath(window.location.pathname + window.location.search)
    }
  }

  // 登录成功后的处理
  async handleLoginSuccess(logindata) {
    console.log("handleLoginSuccess--in")
    
    // 保存 token 和用户信息
    // this.token = logindata.accessToken
    // this.userInfo = { 
    //   uuid: logindata.uuid,
    //   avatar: logindata.avatar,
    //   username: logindata.username,
    //   nickname: logindata.nickname,
    //   sysRole: logindata.sysRole,
    //   orgs: logindata.orgs
    //  }
    
    // console.log("localStorage.setItem-userInfo",JSON.stringify(this.userInfo))
    // console.log("localStorage.setItem-userInfo",JSON.stringify(logindata))

    // localStorage.setItem('uuid', logindata.uuid)
    // localStorage.setItem('user_info', JSON.stringify(this.userInfo))
    // localStorage.setItem('user_role', logindata.sysRole)
    // localStorage.setItem('jwt_token', logindata.accessToken)
    // 兼容不同登录入口：若传入 accessToken/uuid/user 等则落地到 localStorage
    if (logindata && logindata.accessToken) {
      this.token = logindata.accessToken
      localStorage.setItem('jwt_token', this.token)
    }
    if (logindata && logindata.uuid) {
      this.uuid = logindata.uuid
      localStorage.setItem('uuid', this.uuid)
    }
    if (logindata && (logindata.username || logindata.nickname || logindata.sysRole)) {
      this.userInfo = {
        uuid: logindata.uuid,
        avatar: logindata.avatar,
        username: logindata.username,
        nickname: logindata.nickname,
        sysRole: logindata.sysRole,
        orgs: logindata.orgs
      }
      localStorage.setItem('user_info', JSON.stringify(this.userInfo))
      if (logindata.sysRole) localStorage.setItem('user_role', logindata.sysRole)
    }

    // 设置过期时间（后端是秒；此处统一存“绝对毫秒时间”）
    this.expireTime = resolveAccessExpireMs(logindata?.accessExpire)
    localStorage.setItem('expire_time', this.expireTime.toString())
    
    
    // 打印当前时间和过期时间
    console.log(new Date().getTime())
    console.log(this.expireTime)
    
    // 启动定时器
    console.log("startKeepLoginTimer")
    this.startKeepLoginTimer()

    if (logindata) {
      syncAppLogin(logindata)
    } else {
      syncAppSessionFromStorage()
    }

    console.log("handleLoginSuccess--out")
    return this.userInfo
  }

  // 启动保持登录定时器
  startKeepLoginTimer() {
    // 清除现有定时器
    if (this.keepLoginTimer) {
      clearInterval(this.keepLoginTimer)
    }
    
    // 每10分钟执行一次 keepLogin
    this.keepLoginTimer = setInterval(async () => {
      try {
        const response = await axios.post('/api/v1/user/keeplogin', {}, {
          headers: {
            'Authorization': `Bearer ${this.token}`,
            'Content-Type': 'application/json'
          }
        })

        if (response.data && response.data.code) {
          if (response.data.code === 200) {
            console.log(response.data.data)
            // 更新 token 和过期时间
            const { accessToken, accessExpire, uuid, username, nickname, sysRole, permissions } = response.data.data

            this.token = accessToken
            this.expireTime = resolveAccessExpireMs(accessExpire)
            this.userInfo = { uuid, username, nickname, sysRole, permissions }
            console.log("localStorage.setItem", this.userInfo)

            localStorage.setItem('jwt_token', this.token)
            localStorage.setItem('user_info', JSON.stringify(this.userInfo))
            localStorage.setItem('expire_time', this.expireTime.toString())
            localStorage.setItem('user_role', this.userInfo.sysRole)

            syncAppSessionFromStorage()
          } else {
            this.logout()
          }
        }
      } catch (err) {
        console.error('Keep login failed:', err)
        // 如果 keepLogin 失败,清除定时器
        this.stopKeepLoginTimer()
      }
    }, 10 * 60 * 1000) // 每10分钟执行一次
  }

  // 停止保持登录定时器
  stopKeepLoginTimer() {
    if (this.keepLoginTimer) {
      clearInterval(this.keepLoginTimer)
      this.keepLoginTimer = null
    }
  }

  // 登出
  logout() {
    this.token = null
    this.userInfo = {}
    this.expireTime = null
    console.log("removeItem--jwt_token3")
    localStorage.removeItem('jwt_token')
    localStorage.removeItem('user_info')
    localStorage.removeItem('expire_time')
    localStorage.removeItem('uuid')
    this.stopKeepLoginTimer()
  }

  // 检查是否已登录
  isLoggedIn() {
    return !!this.token && this.expireTime && this.expireTime > Date.now()
  }

  // 获取 token
  getToken() {
    return this.token
  }

  // 获取用户信息
  getUserInfo() {
    return this.userInfo
  }
}

// 创建单例
const authManager = new AuthManager()

export default authManager 